import { Billing, UpdateBillingDTO } from "../types/Billing";
import client from "./axios";

const hostBaseUrl = "https://internal-api.getmoveapp.com/api/v1/admin/billingData";
//const hostBaseUrl = "http://localhost:3000/api/v1/admin/billingData";

export const Billings = {
  getBillingDataByUserId: (userId: string) =>
    client.get<{ billing: Billing }>(`${hostBaseUrl}/get-by-user-id/${userId}`),
  getBillingDataByHostId: () =>
    client.get<{ billing: Billing }>(`${hostBaseUrl}`),
  getBillingDataByStructureId: (structureId: string) =>
    client.get<{ billing: Billing }>(
      `${hostBaseUrl}/get-by-structure-id/${structureId}`
    ),
  getBillingData: (id: string) =>
    client.get<{ billing: Billing }>(`${hostBaseUrl}/get-by-id/${id}`),
  updateBillingData: (id: string, data: UpdateBillingDTO) =>
    client.put<{ billing: Billing }>(`${hostBaseUrl}/${id}/update`, data),
};
